<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>
        <router-link :to="{name:'產業新聞'}"><span>產業新聞</span></router-link>
      </div>

      <h2 class="titleA">產業新聞</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'公司簡介'}" class="menu_on0">關於白金</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2279','http://www.ptotinc.com/','0','','2280')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2279"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'公司簡介'}" class="menu_on0">公司簡介</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'經營理念'}" class="menu_on0">經營理念</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'核心競爭力'}" class="menu_on0">核心競爭力</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業沿革'}" class="menu_on0">企業沿革</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業社會責任'}" class="menu_on0">企業社會責任</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'產業新聞'}" class="menu_on2">產業新聞</router-link>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">
          <form
            method="POST"
            action="portal_c2_cnt.php?owner_num=c2_38424&amp;button_num=c2&amp;folder_id=2280&amp;search_type=1"
          >
            <div class="searchbar">
              <ul>
                <li>
                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input
                    tabindex="63"
                    name="search_word"
                    type="text"
                    class="input"
                    value=""
                  />
                  <input
                    tabindex="64"
                    name="search_b1"
                    type="submit"
                    class="btn"
                    value="查詢"
                  />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38424&button_num=c2&folder_id=2280&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

<div class="cate_info">     <strong><span style="font-size: 15px;"><span style="font-size: 18px;"><img alt="" src="~@/assets/15210901971.png"></span></span></strong><br>
&nbsp;
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>中國砸重本、猛併購，為何拚不出第二個台積電？</strong></span></h1>
<em>天下雜誌648期 文． 陳良榕 2018-05-21 </em>

<p style="margin: 0cm 0cm 0pt;"><br>
<span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;; font-size: 13.5pt;"><span style="font-size: 14px;">為了強攻世界龍頭地位，中國以人口紅利、租稅優惠吸引外商設廠，加上整併手段，用「市場換技術」壯大自己的科技產業，早已不是新聞，唯獨半導體像扶不起的阿斗。成立近二十年的中芯，為何原地踏步？</span></span><span style="font-size: 14px;"><span style="font-size: 14px;"><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">「美國現在是要認真地對付中國，」</span><span lang="EN-US" style="font-family: &quot;Arial&quot;,&quot;sans-serif&quot;;">4</span><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">月底，一位美國半導體大廠副總在越洋電話對《天下》記者興奮地說，他相當支持川普對中國打貿易戰、制裁中興。「美國前幾任總統，對中國都太軟弱了，」他說。<br>
<span style="font-size: 14px;"><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">川普政府指責中國竊取美國企業商業機密。他的公司是主要受害者。<span style="font-size: 14px;"><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">「（中國政府的人）晚上衝到我們上海辦公室，叫你開門，直接把電腦裡的資料拿走</span><span lang="EN-US" style="font-family: &quot;Arial&quot;,&quot;sans-serif&quot;;">……</span><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">，」他說，但因該公司高度依賴中國市場，也只能「啞巴吃黃蓮」，默默承受。</span></span><span style="font-size: 14px;"><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">這是中國大陸最擅長的「市場換技術」戰略當中，比較「暗黑」的部份。<span style="font-size: 14px;"><span style="letter-spacing: 0.75pt; font-family: &quot;新細明體&quot;,&quot;serif&quot;;">較常見的方式是，外商被逼著與中國對手、國企成立合資公司「分享」技術，培養未來對手。<span style="font-size: 14px;"><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">例如，近幾年，英特爾曾以</span><span lang="EN-US" style="font-family: &quot;Arial&quot;,&quot;sans-serif&quot;;">15</span><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">億美元入股紫光旗下、由展訊和銳迪科合併的</span><span lang="EN-US" style="font-family: &quot;Arial&quot;,&quot;sans-serif&quot;;">IC</span><span style="font-family: &quot;新細明體&quot;,&quot;serif&quot;;">設計子公司，最近也與中國清華大學合組伺服器晶片公司。</span></span></span></span></span></span></span></span></span></span></span></p>

<div style="text-align: right;">(<a href="https://www.cw.com.tw/article/article.action?id=5090025" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>GBH Insights: Apple will sell 350M iPhone units in the next year</strong></span></h1>
<em>May 30, 2018 7:41 AM ET|About: Apple Inc. (AAPL)|By: Brandy Betz, SA News Editor </em><br>
&nbsp;
<p class="bullets_li"><strong>‧ </strong>GBH Insights expects this year’s Apple (NASDAQ:AAPL) iPhones to sell up to 350M units in the next 12 to 18 months.</p>

<p class="bullets_li"><strong>‧ </strong>Analyst Daniel Ives says many existing iPhone owners didn’t upgrade last year since the 8 and 8 Plus were similar to earlier models and the X was too expensive for many users.</p>

<p class="bullets_li"><strong>‧ </strong>This year’s iPhone lineup is expected to include an X update with a more modest price in the $700 to $800 range and an X Plus for those wanting a premium model.</p>

<p class="bullets_li"><strong>‧ </strong>Ives says China is a significant opportunity with about 100M iPhone customers with about 60M to 70M due for an upgrade over the next 18 months.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3360224-gbh-insights-apple-will-sell-350m-iphone-units-next-year" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>iPhone display makers sink on OLED report</strong></span></h1>
<em>May 29, 2018 3:20 AM ET|By: Yoel Minkoff, SA News Editor </em><br>
&nbsp;
<p class="bullets_li"><strong>‧ </strong>Apple (NASDAQ:AAPL) may be planning to use OLED screens for all its upcoming iPhone models, according to South Korea's Electronic Times.</p>

<p class="bullets_li"><strong>‧ </strong>At the moment, only the iPhone X uses OLED, while the iPhone 8 and iPhone 8 Plus both have LCD screens.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3359817-iphone-display-makers-sink-oled-report" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Apple's HomePod ranks fourth in smart speaker market</strong></span></h1>
<em>May 18, 2018 7:47 AM ET|About: Apple Inc. (AAPL)|By: Brandy Betz, SA News Editor </em><br>
&nbsp;
<p class="bullets_li"><strong>‧ </strong>Apple’s (NASDAQ:AAPL) HomePods only sold 600K units in their first quarter of release, according to Strategy Analytics data.</p>

<p class="bullets_li"><strong>‧ </strong>The performance gives HomePod a 6% smart speaker market share compared to Amazon’s (NASDAQ:AMZN) 4M quarterly Echo sales and 43.6% share and Google’s (GOOG, GOOGL) 2.4M Home sales and 26.5% market share. Alibaba’s (NYSE:BABA) smart speaker came in third with 700K units and a 7.6% share.</p>

<p class="bullets_li"><strong>‧ </strong>But HomePod wasn’t in last place: Xiaomi (BATS:XI) only sold 200K units in the quarter for a 2.4% market share.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3357882-apples-homepod-ranks-fourth-smart-speaker-market" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Bloomberg: Microsoft plans lower-cost Surface tablets to battle Apple</strong></span></h1>
<em>May 16, 2018 8:34 AM ET|By: Brandy Betz, SA News Editor </em><br>
&nbsp;
<p class="bullets_li"><strong>‧ </strong>Microsoft (NASDAQ:MSFT) plans to release a low-cost line of tablets to rival Apple’s iPad, according to Bloomberg.</p>

<p class="bullets_li"><strong>‧ </strong>The new Surface tablets would cost about $400 and feature 10-in. screens, rounded edges, USB-C connectivity (a first for Surfaces), and weight about 20% less than the Pro models. The budget line will have a battery life that’s about four hours less than the Pro line.</p>

<p class="bullets_li"><strong>‧ </strong>Intel (NASDAQ:INTC) will supply the processor and graphics chips, according to Bloomberg sources.</p>

<p class="bullets_li"><strong>‧ </strong>Microsoft previously released the $499 Surface RT in 2012 to limited success before switching to the Surface Pro line.</p>

<p class="bullets_li"><strong>‧ </strong>In the past year, Apple sold 44M iPads for $20B in revenue. Microsoft’s Surface hardware business had sales of $4.4B in the same period.</p>

<p class="bullets_li"><strong>‧ </strong>The new Surface tablets will debut in 2H18.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3357200-bloomberg-microsoft-plans-lower-cost-surface-tablets-battle-apple" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Apple's Self-Driving Tech Project May Be Closer Than It Appears</strong></span></h1>
<em>May 24, 2018 10:29 AM ET|178 comments|About: Apple Inc. (AAPL)</em><br>
&nbsp;
<p><strong>‧ </strong>In summer 2017, Apple admitted to work on self-driving technology.</p>

<p class="bullets_li"><strong>‧ </strong>Little details have been revealed since that time, but automotive-related patents can shed some light on Apple's possible strategy.</p>

<p class="bullets_li"><strong>‧ </strong>The corporation has the second-largest fleet of autonomous cars in California. Apple now has more cars in the region than Tesla or even Waymo.</p>

<p class="bullets_li"><strong>‧ </strong>The automotive market is a very promising source of revenue for Apple, which is another reason to stay long.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/article/4176850-apples-self-driving-tech-project-may-closer-appears" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Bloomberg: TSMC mass producing 7nm chips for Apple's iPhones</strong></span></h1>
<em>May 23, 2018 9:01 AM ET|About: Apple Inc. (AAPL)|By: Brandy Betz, SA News Editor </em><br>
&nbsp;
<p><strong>‧ </strong>Taiwan Semiconductor Manufacturing Co. (NYSE:TSM) has started mass production of its next-gen 7nm processors for the new Apple (NASDAQ:AAPL) iPhones launching this year, according to Bloomberg sources.</p>

<p class="bullets_li"><strong>‧ </strong>The processor will likely be called the A12 chip and will have a smaller and more efficient performance than the 10nm chips in current iPhones.</p>

<p class="bullets_li"><strong>‧ </strong>TSMC announced the 7nm mass production in April but didn’t disclose a partner.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3358900-bloomberg-tsmc-mass-producing-7nm-chips-apples-iphones" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Counterpoint: Apple's Q1 iPhone shipments +16% in U.S.</strong></span></h1>
<em>May 22, 2018 3:17 PM ET|About: Apple Inc. (AAPL)|By: Brandy Betz, SA News Editor </em><br>
&nbsp;
<p><strong>‧ </strong>Apple (NASDAQ:AAPL) iPhone shipments in the U.S. grew 16% Y/Y in Q1, according to Counterpoint data.</p>

<p class="bullets_li"><strong>‧ </strong>Shipments totaled 16M iPhones and the strong showing gave Apple a U.S. market share of 42%.</p>

<p class="bullets_li"><strong>‧ </strong>Samsung (OTC:SSNNF, OTC:SSNLF) came in second with a 22% share with shipments down 4% Y/Y.</p>

<p class="bullets_li"><strong>‧ </strong>Super-premium phones costing more than $800 accounted for 20% of Apple’s Q1 sales and 8% of Samsung’s sales.</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3358695-counterpoint-apples-q1-iphone-shipments-plus-16-percent-u-s" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>CNET: Apple will have AR/VR headset in 2020</strong></span></h1>
<em>Apr. 27, 2018 2:00 PM by <span style="text-decoration: none; text-underline: none;">Brandy Betz</span>, SA News Editor</em>

<p><br>
<strong>‧ </strong>A CNET source says Apple (NASDAQ:AAPL) will have an AR/VR headset ready by 2020.</p>

<p class="bullets_li"><strong>‧ </strong>The source says the project, code-named T288, would include an 8K display for each eye.</p>

<p class="bullets_li"><strong>‧ </strong>CEO Tim Cook is a big proponent of AR and calls it “a big idea like the smartphone.”</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3349997-cnet-apple-will-ar-vr-headset-2020" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<div style="text-align: left;">
<h1><br>
<strong>Trump and Apple's Tim Cook meeting today</strong></h1>
<em>Apr. 25, 2018 12:33 PM ET<span class="sep">|</span>About: Apple Inc. (AAPL)<span class="sep">|</span>By:<span itemprop="author" itemscope="" itemtype="http://schema.org/Person"> <span itemprop="name">Brandy Betz</span></span>, SA News Editor</em>

<p><br>
<strong>‧ </strong>President Donald Trump and Apple (NASDAQ:AAPL) CEO Tim Cook will meet today.</p>

<p class="bullets_li"><strong>‧ </strong>The nature of the talks wasn’t disclosed but come as the potential US-China trade ware heats up.&nbsp;</p>

<p class="bullets_li"><strong>‧ </strong>Apple builds most of its products in China then exports those products around the world.&nbsp;</p>

<p class="bullets_li"><strong>‧ </strong>Yesterday, President Trump said there was a “very good chance” the countries could reach a deal. &nbsp;</p>

<p class="bullets_li"><strong>‧ </strong>Apple shares are up 1.2%.&nbsp;</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3348628-trump-apples-tim-cook-meeting-today" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr>
<h1><span class="_uo1" data-reactid="240" itemprop="headline"><strong>大立光也佩服他！<br>
北台灣的光學獨角獸，打入蘋果關鍵供應鏈</strong></span></h1>
<br>
天下雜誌644期&nbsp;&nbsp; 文．&nbsp; 彭子珊&nbsp;&nbsp;&nbsp;&nbsp; ．&nbsp; 陳良榕&nbsp;&nbsp;&nbsp;&nbsp; 2018-03-26
<p>除了位於台中的大立光，台灣竟出現第二家在蘋果供應鏈有關鍵地位的光學廠？手機業老將、白金科技創辦人兼執行長彭新淼，接受《天下》獨家專訪，談他如何花十一年，打造出世界第二大藍玻璃濾光片廠。<br>
<br>
賈伯斯最後遺作，2011年底上市的蘋果iPhone 4S，是第一支照相品質足以媲美專業單眼相機的手機。有此利器在手，果粉到處自拍打卡的風氣從此一發不可收拾。<br>
<br>
iPhone 4S成像品質大幅提升的關鍵之一，在於蘋果首度在手機相機導入藍玻璃濾光片，可吸收多餘的紅外光，還原物體的真實顏色。此後，藍玻璃濾光片也成為包括三星、小米等所有高階手機相機的標準配備。...</p>

<div style="text-align: right;">(<a href="https://www.cw.com.tw/article/article.action?id=5088932" target="_blank"><font color="#0066cc">READ MORE</font></a>)

<hr>
<div style="text-align: left;">&nbsp;</div>
</div>

<h1><span class="_uo1" data-reactid="240" itemprop="headline"><strong>〈貿易戰延燒科技業〉<br>
傳美準備對中啟動301 台廠恐有潛在風險</strong></span></h1>
<br>
<span class="_3lK" data-reactid="242" itemprop="author" itemscope="" itemtype="https://schema.org/Person"><span data-reactid="243" itemprop="name">鉅亨網記者楊伶雯 台北</span></span><!-- react-text: 244 --><!-- /react-text --><time data-reactid="245" datetime="2018-03-14T17:33:47+08:00">2018/03/14 17:33</time>

<p>根據外電指出，美近期可能擴大對中國進口產品的關稅課徵，總統川普可能啟動美國貿易法 301 條款的相關行動，對高達 600 億<a href="https://www.cnyes.com/forex/html5chart.aspx?fccode=USD/TWD&amp;rate=exchange"><font color="#000000">美元</font></a>中國商品課稅，品項可能多達百項，鎖定科技及電信；中美貿易戰火可能波及台灣在中國設廠的廠商，包括電信、網通設備、科技產品廠是否存有潛在風險值得觀察。<br>
<br>
美國總統川普今年來祭出連串的關稅措施，從太陽能板、洗衣機到最近的鋼鋁關稅等，外電報導表示，根據白宮高級貿易官員指出，對進口鋼鋁課徵懲罰性關稅，是針對中國不公平貿易的第一步行動，下一步則將考慮 301 條款的相關行動...</p>

<div style="text-align: right;">(<a href="https://news.cnyes.com/news/id/4064611" target="_blank"><font color="#0066cc">READ MORE</font></a>)

<hr>
<div style="text-align: left;">
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>跟電動車業者搶資源 蘋果擬直接向礦場購買鈷礦</strong></span></h1>
<br>
<span class="_3lK" data-reactid="242" itemprop="author" itemscope="" itemtype="https://schema.org/Person"><span data-reactid="243" itemprop="name">鉅亨網編譯黃意文 </span></span><!-- react-text: 244 --><!-- /react-text --><time data-reactid="245" datetime="2018-02-21T17:54:27+08:00">2018/02/21 17:54</time>

<p>在電動車加速發展情況，鈷金屬的需求大於供應，而鈷同時為鋰電池的主要原料，據消息人士透露，蘋果正與礦廠接洽，欲簽屬長期供應鈷金屬的合約，以確保有足夠的鈷以提供 iPhone 及 iPad 的電池製造。<br>
<br>
在過去的 18 個月中，鈷金屬的價格已漲了兩倍之多，每噸價格超過 8 萬<a href="https://www.cnyes.com/forex/html5chart.aspx?fccode=USD/TWD&amp;rate=exchange"><font color="#000000">美元</font></a>。<br>
<br>
蘋果為鈷金屬最大的需求者之一，但在過去蘋果將購買鈷金屬的工作，交給其電池供應商，為了確保未來能獲得穩定的鈷金屬供應，知情人士透露，蘋果將親自出馬談論長期供應合約，希望合約年數為 5 年以上，而每年礦商至少能供應數千公噸的鈷金屬，蘋果發言人拒絕發表評論...</p>

<div style="text-align: right;">(<a href="https://news.cnyes.com/news/id/4045576" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>
</div>

<hr></div>

<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>大立光業績疲軟 分析師：首季獲利堪憂 恐引爆另一波殺盤</strong></span></h1>
<br>
<span class="_3lK" data-reactid="242" itemprop="author" itemscope="" itemtype="https://schema.org/Person"><span data-reactid="243" itemprop="name">鉅亨網記者張欽發 台北</span></span><!-- react-text: 244 --><!-- /react-text --><time data-reactid="245" datetime="2018-03-05T19:15:36+08:00">2018/03/05 19:15</time><br>
<br>
股王大立光 (3008-TW) 今 (5) 日公布 2 月營收為 22.17 億元，月減 36.82%，年減 35.37%，為 2 年來營收新低，雖然 3 月營收可望回升，今日股價也勉強守住 3700 元大關，但證券分析師認為，目前手機產業對大立光相當不利，不排除引發另一波殺盤的摜壓股價。<br>
<br>
證券分析師張陳浩指出，目前大立光公布的前 2 月營收表現不振，其他重要手機零組件廠商、甚至如 EMS 廠鴻海 (2317-TW) 2 月營收表現恐怕也有壓力，目前市場悲觀態度難免...
<div style="text-align: right;">(<a href="https://news.cnyes.com/news/id/4054224" target="_blank">READ MORE</a>)</div>
&nbsp;

<hr>&nbsp;
<h1><span class="_uo1" data-reactid="240" itemprop="headline"><strong>Apple supplier Finisar will start production at new plant in October</strong></span></h1>
<br>
Mar. 5, 2018 8:02 AM ET<span class="sep">|</span>About: Finisar Corporation (FNSR)<span class="sep">|</span>By:<span itemprop="author" itemscope="" itemtype="http://schema.org/Person"> <span itemprop="name">Brandy Betz</span></span>, SA News Editor<br>
&nbsp;
<p class="bullets_li">Finisar (NASDAQ:FNSR)&nbsp;gains 2.4%&nbsp;to $18.60 premarket after telling a local news outlet that production will soon begin at its Sherman, Texas plant.&nbsp;</p>

<p class="bullets_li">VP and GM Curtis Barratt tells TV station KXII: “About 90 percent of the equipment is on order, and we’ll bring that in starting in April or May. We’ll start the line first articles by August and production will get going by October.”</p>

<p class="bullets_li">Last December, Apple paid Finisar $390M against future orders, which went towards funding the 700K square foot plant in Sherman.&nbsp;</p>

<p class="bullets_li">Finisar produces vertical-cavity surface-emitting lasers (VCSELs), a laser tech used in the iPhone X’s Face ID system and Portrait-mode pictures.</p>

<p class="bullets_li">Bloomberg sources recently said three new iPhones will release this year and all will include Face ID...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3336328-apple-supplier-finisar-will-start-production-new-plant-october" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>

<hr>
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Amazon: Homes Become Assistants</strong></span></h1>
<br>
<span><time content="2018-03-12T16:17:25Z" itemprop="datePublished">Mar.12.18</time> | <span>About:</span> <span><font color="#000000">Amazon.com, Inc. (AMZN)</font> </span></span><br>
&nbsp;
<div class="a-sum" itemprop="description">
<p>AMZN recently agreed to a $1 billion deal to acquire Ring, a home security manufacturer.</p>

<p>Ring's internet connected home security products integrates well with the popular Echo range.</p>

<p>More rivalry and competition between AMZN and GOOG in smart-homes and smart-cities, a key growth sector in the coming years.</p>
</div>

<div class="sa-art article-width" id="a-body" itemprop="articleBody">
<p class="p p1">At the Consumer Electronics Show in January 2018, popular products in the past year such as drones, GoPros and 4K TVs, have had to stand aside for the newest addition in technology -- smart homes. Powered by voice recognition technology, major technology firms such as Amazon (AMZN), Google (GOOG) (NASDAQ:GOOGL), Apple (AAPL) and Samsung (SSLNF) have devoted much of their new product R&amp;D efforts into this particular niche...</p>
</div>

<div style="text-align: right;">(<a href="https://seekingalpha.com/article/4155583-amazon-homes-become-assistants" target="_blank"><font color="#0066cc">READ MORE</font></a>)</div>

<hr>
<h1><br>
<span class="_uo1" data-reactid="240" itemprop="headline"><strong>Apple hit new high today in race towards $1T market cap</strong></span></h1>
<br>
Mar. 12, 2018 4:53 PM ET<span class="sep">|</span>About: Apple Inc. (AAPL)<span class="sep">|</span>By:<span itemprop="author" itemscope="" itemtype="http://schema.org/Person"> <span itemprop="name">Brandy Betz</span></span>, SA News Editor<span><span> </span></span><br>
&nbsp;
<div class="a-sum" itemprop="description">
<p>Apple (NASDAQ:AAPL) hit a new high today as shares bumped $182 intraday before slipping back down slightly.</p>

<p class="bullets_li">The move put Apple’s market cap over $925B, ahead of Alphabet and Amazon, in the race towards the $1T mark.&nbsp;</p>

<p class="bullets_li">Apple shares closed the day&nbsp;up 1%&nbsp;to $181.72.&nbsp;&nbsp;</p>

<p class="bullets_li">Previously: Apple Music hits 38M paid subscribers; Apple orders first animated series (March 12)...</p>
</div>

<div style="text-align: right;">(<a href="https://seekingalpha.com/news/3338511-apple-hit-new-high-today-race-towards-1t-market-cap" target="_blank"><font color="#0066cc">READ MORE</font></a>)

<hr></div>
 </div>

          <ul id="c_list"></ul>

          <br /><br />
          <p style="text-align: center"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'news',
  // mixins: [sliderPro],
  data () {
    return {
      msg: '產業新聞'
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    // sliderPro.m1()
    // sliderProAddTitle('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
    // sliderPro.initialSliderPro()
    // sliderPro.m1('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/about/News.vue